import { apiClient } from '../client';
import { API_CONFIG } from '../config';
import type { MetaAccountRestriction } from '@/lib/whatsapp/accountRestrictions';

export interface BusinessAccount {
  id: string;
  business_account_id: string;
  name: string;
  phone_number: string;
  phone_number_id: string;
  access_token_encrypted: string;
  is_active: boolean;
  quality_rating?: string;
  connection_type?: string | null;
  coexistence_state?: 'OFFBOARDED' | 'DISCONNECTED' | null;
  coexistence_reason?: string | null;
  coexistence_state_at?: string | null;
  coexistence_onboarded_at?: string | null;
  history_sync_status?: 'REQUESTED' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED' | 'REFUSED' | null;
  history_sync_requested_at?: string | null;
  history_sync_progress?: number | null;
  history_sync_progress_at?: string | null;
  history_sync_completed_at?: string | null;
  history_sync_error?: string | null;
  restrictions?: MetaAccountRestriction[] | null;
  created_at: string;
  updated_at: string;
}

export interface CreateBusinessAccountData {
  name: string;
  phone_number: string;
  phone_number_id: string;
  business_account_id: string;
  access_token_encrypted: string;
}

export interface UpdateBusinessAccountData {
  name?: string;
  phone_number?: string;
  phone_number_id?: string;
  access_token_encrypted?: string;
  is_active?: boolean;
}

export interface BusinessAccountFilters {
  is_active?: boolean;
  business_account_id?: string;
  workspace_id?: string;
}

export const businessAccountsApi = {
  async getAll(filters?: BusinessAccountFilters) {
    const params = new URLSearchParams();
    if (filters?.is_active !== undefined) {
      params.append('is_active', filters.is_active.toString());
    }
    if (filters?.workspace_id) {
      params.append('workspace_id', filters.workspace_id);
    }
    if (filters?.business_account_id) {
      params.append('business_account_id', filters.business_account_id);
    }

    const queryString = params.toString();
    const url = queryString ? `/business-accounts?${queryString}` : '/business-accounts';
    
    return apiClient.get<BusinessAccount[]>(url);
  },

  async getById(id: string) {
    return apiClient.get<BusinessAccount>(`/business-accounts/${id}`);
  },

  async create(data: CreateBusinessAccountData) {
    return apiClient.post<BusinessAccount>('/business-accounts', data);
  },

  async update(id: string, data: UpdateBusinessAccountData) {
    return apiClient.put<BusinessAccount>(`/business-accounts/${id}`, data);
  },

  async delete(id: string) {
    return apiClient.delete(`/business-accounts/${id}`);
  },

  async updateLeadFormLayout(id: string, layout: unknown | null) {
    return apiClient.put<BusinessAccount>(`/business-accounts/${id}/lead-form-layout`, {
      lead_form_layout: layout,
    });
  }
};
